import { AnyAction, Store, ThunkDispatch, configureStore } from '@reduxjs/toolkit';
import rootReducer, { RootState } from './reducers';

function configureAppStore(preloadedState: any) {
    const store = configureStore({
        reducer: rootReducer,
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware({
                // State holds Date instances and NSwag DTO class instances.
                serializableCheck: false,
            }),
        preloadedState,
    });

    return store;
}

export default configureAppStore;

export type AppThunkDispatch = ThunkDispatch<RootState, any, AnyAction>;

export type AppStore = Omit<Store<RootState, AnyAction>, 'dispatch'> & {
    dispatch: AppThunkDispatch;
};
